import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { Grid } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import MaterialTable from '@material-table/core';
import MainCard from '../../../ui-component/cards/MainCard';
import SecondaryAction from '../../../ui-component/cards/CardSecondaryAction';
import { gridSpacing } from '../../../store/constant';
import { ExportCsv, ExportPdf } from '@material-table/exporters';
import { Link } from 'react-router-dom';
import { Label } from 'reactstrap';
import axiosInstance from '../../../axiosInstance';
import { IconDownload, IconUpload, IconListDetails } from '@tabler/icons';
import { useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { Divider, Input } from '@mui/material';
import configData from '../../../config';
import * as XLSX from 'xlsx';

const icons = {
    IconDownload,
    IconUpload,
    IconListDetails
};

const columns = [
    { title: 'Account Name', field: 'account_name' },
    { title: 'Default Account Grouping', field: 'account_type1' },
    { title: 'Account Grouping 1', field: 'account_type2' },
    { title: 'Account Grouping 2', field: 'account_type3' },
    { title: 'Account Grouping 3', field: 'account_type4' },
    { title: 'Account Grouping 4', field: 'account_type5' },
    { title: 'Account Grouping 5', field: 'account_type6' },
    { title: 'Account Grouping 6', field: 'account_type7' },
    { title: 'Account Grouping 7', field: 'account_type8' },
    { title: 'Account Grouping 8', field: 'account_type9' },
    { title: 'Account Grouping 9', field: 'account_type10' }
];

const currency = ['INR', 'USD'];

const account_type = [
    {type: "account_type1"},
]

function MonthWise() {
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [apiData, setAPIData] = useState([]);
    const [tableRowData, setTableRowData] = useState();
    const [exportData, setExportData] = useState()

    const org_id = useSelector((state) => (state?.account?.org !== null ? state?.account?.org?.id : state?.account?.org_data?.data?.id));

    const {
        control,
        register,
        handleSubmit,
        watch,
        setValue,
        formState: { errors }
    } = useForm({
        defaultValues: {
            account_group: '',
            add_account_group: '',
            add_account_name: '',
            currency: ''
        }
    });

    const tableActions = [
        {
            icon: () => (
                <span style={{ display: 'flex', alignItems: 'center', paddingLeft: '12px' }}>
                    <p
                        style={{
                            fontSize: '15px',
                            paddingTop: '3px',
                            color: 'gray',
                            fontWeight: '600'
                        }}
                    >
                        Data Count : <span style={{ color: 'black' }}>dahdas</span>
                    </p>
                </span>
            ),

            tooltip: 'Data Count',
            isFreeAction: true
        }
    ];

    // const timeFormatData = apiData.map((obj, index) => {
    //      const basicMonth = obj.month;
    //      const [startDateString, endDateString] = basicMonth.split("-");
    //      if (endDateString == '01') {
    //           obj.month = 'January';
    //      } else if (endDateString == '02') {
    //           obj.month = 'February';
    //      } else if (endDateString == '03') {
    //           obj.month = 'March';
    //      } else if (endDateString == '04') {
    //           obj.month = 'April';
    //      } else if (endDateString == '05') {
    //           obj.month = 'May';
    //      }
    //      else if (endDateString == '06') {
    //           obj.month = 'June';
    //      }
    //      else if (endDateString == '07') {
    //           obj.month = 'July';
    //      }
    //      else if (endDateString == '08') {
    //           obj.month = 'August';
    //      }
    //      else if (endDateString == '09') {
    //           obj.month = 'September';
    //      } else if (endDateString == '10') {
    //           obj.month = 'October';
    //      } else if (endDateString == '11') {
    //           obj.month = 'November';
    //      } else if (endDateString == '12') {
    //           obj.month = 'December';
    //      }
    //      return obj;
    // });

    //////////////////////////////////////////////////////////////////////////
    ////////////////////////////Upload functionality//////////////////////////
    //////////////////////////////////////////////////////////////////////////

    const handleFileChange = async (file) => {
        console.log(file);

        const fileExtension = getFileExtension(file.name);
        console.log(fileExtension);
        if (isValidFileExtension(fileExtension)) {
            setSelectedFile(file);
            // handleUpload(file);
        } else {
            // Invalid file format
            alert('Invalid file format. Please select a CSV, XLSX, or XLS file.');
        }
        // setSelectedFile(file)
    };

    const getFileExtension = (filename) => {
        return filename.split('.').pop().toLowerCase();
    };

    const isValidFileExtension = (extension) => {
        const allowedExtensions = ['csv', 'xlsx', 'xls'];
        return allowedExtensions.includes(extension);
    };

    const handleUpload = async () => {
        console.log('in handle upload');
        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('org_id', org_id);

            const response = await axiosInstance.post('https://api.projectivetech.com/account/upload_chart_of_account/', formData);
            // const response = await axiosInstance.post('http://127.0.0.1:8000/account/upload_chart_of_account/', formData);
            console.log(response);
            alert('File successfully uploaded.');
            setSelectedFile(null);
            getData()
        } else {
            alert('Please upload file in appropriate format.');
        }
    };

    useEffect(() => {
        if (selectedFile) handleUpload();
    }, [selectedFile]);

   
    const getData = async () => {
        // setLoading(true);
        try {
            if (org_id) {
                const res = await axiosInstance.get(configData.API_SERVER + `/account/get_chart_of_account?org_id=${org_id}`);
                // const res = await axiosInstance.get(`http://127.0.0.1:8000/account/get_chart_of_account?org_id=${org_id}`);
                setAPIData(res.data.data);
            }
            // setCount(actualData.data.length);
        } catch (error) {
            setAPIData([]);
        }
    };
    useEffect(() => {
        getData();
    }, []);

    // Filter columns based on the presence of data in the field
    const filteredColumns = columns.filter(column => {
        // Skip 'Account Name' column as it's always shown
        if (column.field === 'account_name') {
            return true;
        }
        // Check if any data exists for the field
        return apiData.some(data => !!data[column.field]);
    });


    const TableData = apiData;

    const removeNullValues = (data) => {
        return data.map(obj => {
            const newObj = {};
            Object.keys(obj).forEach(key => {
                if (obj[key] !== null) {
                    newObj[key] = obj[key];
                }
            });
            return newObj;
        });
    };

    const getCOAForExport = async ()=>{
        console.log('in get coa')
        try {
            // const res = await axiosInstance.get(`http://127.0.0.1:8000/account/get_coa_by_org_id?org_id=${org_id}`)
            const res = await axiosInstance.get(configData.API_SERVER + `/account/get_coa_by_org_id?org_id=${org_id}`)
            console.log(res);
            const filteredData = removeNullValues([...res.data.data]);
            setExportData([...filteredData])
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
      if(exportData)
        exportToExcel(exportData)
    }, [exportData])
    

    const exportToExcel = async (exportData) => {
        if(exportData){
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        
            const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' }); // Specify type as buffer
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'COA Template.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
      };

    const selectFilterOptions = filteredColumns.filter((ele)=> ele.field !== 'account_name')
    const toggle = () => {
        setModal(!modal);
        setValue('account_group', '');
        setValue('acount_type_key', '');
        // setIsAdd(false)
    };

    const actions = [
        {
            icon: icons.IconListDetails,
            tooltip: 'Update Account Groupings',
            onClick: async (event, rowData) => {
                // Trigger file input click
                toggle();
                setTableRowData(rowData);
                // document.getElementById('fileInput').click();
                //     await handleUpload(rowData);
            }
        }
    ];

    const watchFields = watch('account_group');
    const acount_type_key = watch('acount_type_key');
    const onSubmit = async () => {
        if (tableRowData){
            const data = {
                account_id: '',
                // org_id: ''
            };
            data[acount_type_key] = watchFields;
            data.account_id = tableRowData.account_id;
            // data.org_id = tableRowData.org_id_id;
            console.log(data);  
            try {
                const res = await axiosInstance.put(configData.API_SERVER + `/account/update_chart_of_accounts`, data);
                // const res = await axiosInstance.put(`http://127.0.0.1:8000/account/update_chart_of_accounts`, data);
                alert(res.data.message);
                getData();
                toggle();
                
            } catch (error) {
                console.log(error);
            }

        }
    };

    useEffect(() => {
        if (isAdd) {
            toggle();
        }
    }, [isAdd]);

    const addCoa = async (data) => {
        const add_account_group = watch('add_account_group')
        const add_account_name = watch('add_account_name')
        const add_currency = watch('currency')

        const updateData = {
            account_name: '',
            currency: '',
            account_type1: '',
            org_id: ''
        }
        
        updateData.account_name = add_account_name;
        updateData.currency = add_currency;
        updateData.account_type1 = add_account_group;
        updateData.org_id = org_id;

        try {
            const res = await axiosInstance.post(configData.API_SERVER + `/account/add_new_account`, updateData);
            // const res = await axiosInstance.post(`http://127.0.0.1:8000/account/add_new_account`, updateData);
            console.log(res);
            alert(res.data.message);
            getData();
            toggle();
            setIsAdd(false)
        } catch (error) {
            console.log(error);
        }
    };

    const addGroupings = async ()=>{
        try {
            const res = await axiosInstance.post(configData.API_SERVER + `/account/add_account_groupings`, { org_id: org_id });
            // const res = await axiosInstance.post(`http://127.0.0.1:8000/account/add_account_groupings`, { org_id: org_id } )
            console.log(res);
            getData();
        } catch (error) {
            console.log(error);
        }
    }



    return (
        <>
            <MainCard title="Chart of Accounts" secondary={<SecondaryAction />}>
                <Grid container spacing={gridSpacing} style={{ padding: '0px' }}>
                    <div className="d-flex " style={{ float: 'right', width: '100%', justifyContent: 'flex-end', marginTop: '10px' }}>
                        <input
                            type="file"
                            id="upload-btn"
                            onChange={(e) => {
                                handleFileChange(e.target.files[0]);
                            }}
                            style={{ display: 'none' }}
                        />
                        <label for="upload-btn" className="custom-upload-btn" >
                            Upload COA
                        </label>
                        <label className="custom-upload-btn" onClick={getCOAForExport} style={{ marginLeft: '5px' }}>
                            Export Chart of Accounts
                        </label>
                        <label
                            className="custom-add-btn "
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                setIsAdd(true);
                            }}
                        >
                            Add New Account 
                        </label>
                        <label
                            className="custom-add-btn"
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                addGroupings()
                            }}
                        >
                            Add Account Groupings 
                        </label>
                    </div>
                </Grid>
                <br></br>
                {/* <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid">
                        <Grid lg={6} sm={6} style={{ float: 'right' }}>
                            <input
                                type="file"
                                id="upload-btn"
                                onChange={(e) => {
                                    handleFileChange(e.target.files[0]);
                                }}
                                style={{ display: 'none' }}
                            />
                            <label for="upload-btn" className="custom-upload-btn">
                                Upload Chart of Accounts
                            </label>
                            <span style={{ marginLeft: '5px' }}>{selectedFile ? selectedFile.name : 'No file choosen'}</span>
                        </Grid>
                    
                    </Grid>
                </Grid> */}

                <Grid container spacing={gridSpacing}>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        className="hiddenscrollDiv"
                        style={{ maxWidth: '100%', width: '100%', overflowX: 'scroll' }}
                    >
                        <MaterialTable
                            //    actions={tableActions}
                            actions={actions}
                            isLoading={loading}
                            title={'Chart of Accounts Grouping'}
                            columns={filteredColumns}
                            data={TableData}
                            options={{
                                pageSize: 20,
                                actionsColumnIndex: 0,
                                search: false,
                                grouping: false,
                                columnsButton: false,
                                paging: true,
                                showFirstLastPageButtons: false,
                                filtering: false,
                                // columnsButton: true,
                                exportMenu: [
                                    //  {
                                    //       label: "Export PDF",
                                    //       exportFunc: (cols, datas) =>
                                    //            ExportPdf(cols, datas, "myPdfFileName"),
                                    //  },
                                    //  {
                                    //       label: "Export CSV",
                                    //       exportFunc: (cols, datas) =>
                                    //            ExportCsv(cols, datas, "myCsvFileName"),
                                    //  },
                                ],
                                headerStyle: {
                                    backgroundColor: 'rgba(173, 216, 230, 0.281)',
                                    color: 'black',
                                    width: '100vw',
                                    height: '80px',
                                    textAlign: 'left',
                                    fontSize: '13px',
                                    fontWeight: 'bolder'
                                },
                                cellStyle: {
                                    textAlign: 'left',
                                    color: 'black',
                                    fontSize: '12.5px'
                                }
                            }}
                        />
                        <br></br> <br></br>
                    </Grid>
                </Grid>
            </MainCard>

            <Modal isOpen={modal} toggle={toggle} backdrop={true} centered={true} size="md">
                <ModalHeader
                    toggle={() => {
                        toggle();
                        setIsAdd(false);
                    }}
                >
                    {isAdd === true ? 'Add Account Groupings' : 'Update Account Groupings'}
                </ModalHeader>
                <ModalBody>
                    {isAdd !== true ? (
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                                    <Grid lg={12} md={12} sm={12} xs={12} className="sad_Single">
                                        <Label style={{ fontSize: '14px !important' }}>
                                            Account Name<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <Input
                                            className="form-control "
                                            placeholder="Enter Name"
                                            {...register('account_name')}
                                            defaultValue={tableRowData?.account_name}
                                            disabled
                                        />
                                        {errors.account_name && (
                                            <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                {errors.account_name.message}
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                                <Grid
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="sad_Single"
                                        style={{ marginBottom: '5px', marginTop: '-25px' }}
                                    >
                                        <Label style={{ fontSize: '14px !important' }}>
                                            Currency<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <select
                                            className="form-select "
                                            style={{ cursor: 'pointer' }}
                                            {...register('acount_type_key', { required: 'Please Select Currncy' })}
                                        >
                                            {/* <option value={''} style={{ color: 'gray' }}>
                                            Select Industry
                                            </option> */}
                                            {selectFilterOptions.map((item, index) => {
                                                return (
                                                    <>
                                                        <option key={index} value={item.field}>
                                                            {item.title}
                                                        </option>
                                                    </>
                                                );
                                            })}
                                        </select>
                                        {errors.acount_type_key && (
                                            <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>
                                                {errors.acount_type_key.message}
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                                    <Grid
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="sad_Single"
                                        style={{ marginTop: '-35px', marginBottom: '10px' }}
                                    >
                                        <Label style={{ fontSize: '14px !important' }}>
                                            New Account Group<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <Input
                                            className="form-control "
                                            placeholder="Enter Name"
                                            {...register('account_group', { required: 'Account Group Is Required' })}
                                            defaultValue=""
                                        />
                                        {errors.account_group && (
                                            <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                {errors.account_group.message}
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} justifyContent="flex-end">
                                <Grid item>
                                    <Button
                                        type="submit"
                                        color="success"
                                        onClick={() => {
                                            onSubmit();
                                            setTableRowData();
                                        }}
                                    >
                                        Update
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        color="danger"
                                        onClick={() => {
                                            setTableRowData();
                                            toggle();
                                            setIsAdd(false);
                                        }}
                                    >
                                        Close
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    ) : (
                        <form onSubmit={handleSubmit(addCoa)}>
                            <Grid container spacing={2}>
                                <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                                    <Grid lg={12} md={12} sm={12} xs={12} className="sad_Single">
                                        <Label style={{ fontSize: '14px !important' }}>
                                            Account Name<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <Input
                                            className="form-control "
                                            defaultValue=""
                                            placeholder="Enter Name"
                                            {...register('add_account_name', { required: 'Account Name Is Required' })}
                                        />
                                        {errors.add_account_name && (
                                            <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                {errors.add_account_name.message}
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                                    <Grid
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="sad_Single"
                                        style={{ marginTop: '-35px', marginBottom: '10px' }}
                                    >
                                        <Label style={{ fontSize: '14px !important' }}>
                                            Account Group<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <Input
                                            className="form-control "
                                            placeholder="Enter Name"
                                            defaultValue=""
                                            {...register('add_account_group', { required: 'Account Group Is Required' })}
                                        />
                                        {errors.add_account_group && (
                                            <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                {errors.add_account_group.message}
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                                    <Grid
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="sad_Single"
                                        style={{ marginTop: '-45px', marginBottom: '30px' }}
                                    >
                                        <Label style={{ fontSize: '14px !important' }}>
                                            Currency<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                        <select
                                            className="form-select "
                                            style={{ cursor: 'pointer' }}
                                            {...register('currency', { required: 'Please Select Currncy' })}
                                        >
                                            {/* <option value={''} style={{ color: 'gray' }}>
                                            Select Industry
                                        </option> */}
                                            {currency.map((item, index) => {
                                                return (
                                                    <>
                                                        <option key={index} value={item}>
                                                            {item}
                                                        </option>
                                                    </>
                                                );
                                            })}
                                        </select>
                                        {errors.currency && (
                                            <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>
                                                {errors.currency.message}
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} justifyContent="flex-end">
                                <Grid item>
                                    <Button
                                        type="submit"
                                        color="success"
                                        onClick={() => {
                                            addCoa();
                                        }}
                                    >
                                        Update
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        color="danger"
                                        onClick={() => {
                                            toggle();
                                            setIsAdd(false);
                                        }}
                                    >
                                        Close
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </ModalBody>
            </Modal>

            <Grid item xs={12} className="sub_div">
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} md={6} sm={6} xs={12}>
                        <Grid className="col-12 col-sm-12 text-center footer_inner_div">&copy; {new Date().getFullYear()} IMAGE-I</Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default MonthWise;
